import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "../api/services/dashboard/dashboardService";
import { DashboardParams } from "../api/services/dashboard/type";

export const useDashboardData = (params?: DashboardParams) => {
  return useQuery({
    queryKey: ["dashboard", params],
    queryFn: () => dashboardService.getDashboardData(params),
    refetchInterval: 30000,
    staleTime: 20000,
  });
};

export const useCashFlowData = (params?: DashboardParams) => {
  return useQuery({
    queryKey: ["dashboard-cash-flow", params],
    queryFn: () => dashboardService.getCashFlowData(params),
    refetchInterval: 30000,
    staleTime: 20000,
  });
};

export const useExpenseBreakdown = (params?: DashboardParams) => {
  return useQuery({
    queryKey: ["dashboard-expense-breakdown", params],
    queryFn: () => dashboardService.getExpenseBreakdown(params),
    refetchInterval: 60000,
    staleTime: 50000,
  });
};
